import {getApplicationsWithAccess} from '@/helpers/applicationAccess'
import {getApplicationsUseCase} from '@/useCases/getApplicationsUseCase'
import {useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'

type UseApplicationsOptions = {
  enabled?: boolean
}

export const useApplications = ({
  enabled = Boolean(localStorage.getItem('msalAccessToken')),
}: UseApplicationsOptions = {}) => {
  const query = useQuery({
    queryKey: ['tenant-applications'],
    queryFn: ({signal}) => getApplicationsUseCase(signal),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  })

  const applications = useMemo(() => {
    if (query.data) {
      return getApplicationsWithAccess(query.data.applications)
    }

    return []
  }, [query.data])

  return {
    ...query,
    applications,
    allApplications: query.data?.applications ?? [],
  }
}
